import {reducer} from './helpers'
import {GET_CURRENT_EVENT_SUCCESS, LOGIN_SUCCESS, REGISTRATION_SUCCESS} from '../actions/api'
import {
  ADD_CURRENT_EVENT_TO_ALL_EVENTS,
  CHANGE_CURRENT_EVENT_COMPLETED,
  CHANGE_CURRENT_EVENT_FAILURE,
  CHANGE_CURRENT_EVENT_PENDING,
  CHANGE_CURRENT_EVENT_SUCCESS,
  CLEAR_CURRENT_EVENT,
  CREATE_NEW_EVENT_FAILURE,
  CREATE_NEW_EVENT_SUCCESS,
  DELETE_EVENT_FAILURE,
  DELETE_EVENT_SUCCESS,
  GET_ALL_EVENTS_FAILURE,
  GET_ALL_EVENTS_SUCCESS,
  UPDATE_CURRENT_DATE,
  UPDATE_CURRENT_EVENT,
  UPDATE_CURRENT_NUM_MEMBERS,
  UPDATE_CURRENT_OWNER_ROLE,
  UPDATE_CURRENT_TYPE,
  UPDATE_PARTNER_INFO_PENDING,
  UPDATE_PARTNER_INFO_FAILURE,
  UPDATE_PARTNER_INFO_SUCCESS,
} from '../actions/events'
import {EVENT_IN_PROGRESS, ApiRequestStates} from '../const'
import {FieldValidationErrors} from '../exceptions'

// This maps current event data to allEvents data structure,
// We will either merge this to an existing event or build a new event off it
export const eventDataMap = (current) => ({
  date: current.date,
  id: current.id,
  name: current.name,
  type: current.type,
  numMembers: current.numMembers,
  orderId: current.orderId,
  owner: current.owner,
  ownerRole: current.ownerRole,
  status: EVENT_IN_PROGRESS,
  userId: current.owner,
})

export const initialState = {
  current: {},
  updatePartnerInfoRequestStatus: ApiRequestStates.IDLE,
  updatePartnerInfoRequestErrors: {},
}

export default reducer(initialState, (state, action) => {
  const {type, payload} = action

  switch (type) {
    case ADD_CURRENT_EVENT_TO_ALL_EVENTS:
      // if eventId already exists in all, merge data in case of edits done to current event
      // otherwise, push new data to keep events.all in sync
      if (payload && payload.currentEventIsInAll) {
        return {
          all: state.all.map((event) => {
            if (event.id !== state.current.id) {
              return event
            }
            return {
              ...event,
              ...eventDataMap(state.current),
            }
          }),
        }
      }

      return {
        all: [...state.all, eventDataMap(state.current)],
      }
    case CHANGE_CURRENT_EVENT_COMPLETED:
      return {currentEventIsChanging: false}
    case CHANGE_CURRENT_EVENT_FAILURE:
      return {hasError: true}
    case CHANGE_CURRENT_EVENT_PENDING:
      return {currentEventIsChanging: true}
    case CHANGE_CURRENT_EVENT_SUCCESS:
      return {
        current: {
          date: payload.date,
          id: payload.id,
          name: payload.name,
          numMembers: payload.numMembers,
          orderId: payload.orderId,
          owner: payload.owner,
          ownerRole: payload.ownerRole,
          type: payload.type,
        },
      }
    case CLEAR_CURRENT_EVENT:
      return {current: {...initialState.current}}
    case CREATE_NEW_EVENT_FAILURE:
      return {hasError: true}
    case CREATE_NEW_EVENT_SUCCESS:
      return {...state, ...{current: payload}}
    case DELETE_EVENT_FAILURE:
      return {hasError: true}
    case DELETE_EVENT_SUCCESS:
      return {
        all: state.all.filter((event) => event.id !== payload),
      }
    case GET_ALL_EVENTS_FAILURE:
      return {hasError: true}
    case GET_ALL_EVENTS_SUCCESS:
      return {
        all: payload,
        allEventsAreFetched: true,
      }
    case GET_CURRENT_EVENT_SUCCESS:
      return {current: payload || {}} // keep an object, at minimum, to prevent bugs
    // store the event id and owner id off login and registration so we can
    //  immediately determine whether the user is a participant or not
    case LOGIN_SUCCESS:
    case REGISTRATION_SUCCESS:
      return {
        current: {
          ...state.current,
          id: payload.event.id,
          owner: payload.event.owner,
        },
      }
    case UPDATE_CURRENT_DATE:
      return {
        current: {
          ...state.current,
          date: payload,
        },
      }
    case UPDATE_CURRENT_EVENT:
      return {
        current: {
          ...state.current,
          ...payload,
        },
      }
    case UPDATE_CURRENT_NUM_MEMBERS:
      return {
        current: {
          ...state.current,
          numMembers: payload,
        },
      }
    case UPDATE_CURRENT_OWNER_ROLE:
      return {
        current: {
          ...state.current,
          ownerRole: payload,
        },
      }
    case UPDATE_CURRENT_TYPE:
      return {
        current: {
          ...state.current,
          ownerRole: null,
          type: payload,
        },
      }
    case UPDATE_PARTNER_INFO_PENDING:
      return {
        updatePartnerInfoRequestErrors: initialState.updatePartnerInfoRequestErrors,
        updatePartnerInfoRequestStatus: ApiRequestStates.PENDING,
      }
    case UPDATE_PARTNER_INFO_FAILURE:
      if (payload instanceof FieldValidationErrors) {
        return {
          updatePartnerInfoRequestErrors: payload.errors,
          updatePartnerInfoRequestStatus: ApiRequestStates.ERROR,
        }
      }

      return {
        updatePartnerInfoRequestErrors: {message: payload.message},
        updatePartnerInfoRequestStatus: ApiRequestStates.ERROR,
      }
    case UPDATE_PARTNER_INFO_SUCCESS:
      return {
        current: {
          ...state.current,
          metadata: {
            ...state.current.metadata,
            ...payload,
          },
        },
        updatePartnerInfoRequestStatus: ApiRequestStates.SUCCESS,
      }
    default:
      return null
  }
})
